export enum RouteItineraryTravelPosition {
  Start = 1,
  TaskToTask = 2,
  End = 3,
}
